/**
 * Yandex.Metrika goal tracking helper.
 * Counter ID: 106989563
 */

declare global {
  interface Window {
    ym?: (counterId: number, method: string, goal: string, params?: Record<string, unknown>) => void;
  }
}

const COUNTER_ID = 106989563;

export function reachGoal(goal: string, params?: Record<string, unknown>) {
  if (typeof window !== "undefined" && window.ym) {
    window.ym(COUNTER_ID, "reachGoal", goal, params);
  }
}
